import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import SlideCarousel from '@r1-frontend/ui-react/components/SlideCarousel';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import PageSection from '~/src/features/domru-tv/packages/components/PageSection';

export const LayoutWrapper = styled(WideContainer)`
    flex-direction: column;
    row-gap: 40px;
    margin-top: 24px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-top: 16px;
        padding-left: 7px;
        padding-right: 0px;
    }
`;

export const BackButton = styled(BaseButton)`
    align-self: flex-start;
    padding-left: 0;
`;

export const HeadRow = styled.div`
    gap: 8px;
    justify-content: space-between;
    align-items: center;

    @media (max-width: ${wideBreakpoints.mobile}) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const LayoutTitle = styled.h1`
    ${FONTS.H2};
    margin: 0;

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H3};
    }
`;

export const FilterBlock = styled.div`
    gap: 16px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 100%;
        justify-content: space-between;
        gap: 12px;
    }
`;

export const FilterLabel = styled.p`
    ${FONTS.MediumS};
`;

export const LayoutSection = styled(PageSection)`
    row-gap: 24px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        row-gap: 16px;
    }
`;

export const ContentCarousel = styled(SlideCarousel)`
    & > section > div.slider-control-bottomcenter {
        max-width: 100%;
    }

    & > section > div.slider-control-centerleft {
        left: -34px !important;
    }

    & > section > div.slider-control-centerright {
        right: -34px !important;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        & > section > div.slider-control-centerleft {
            left: -28px !important;
        }

        & > section > div.slider-control-centerright {
            right: -28px !important;
        }
    }
`;
